import React, { Component } from 'react';
import ProjectsLayout from '../../templates/project';
import ProjectGoalEditForm from '../../elements/project/registry';
import Loading from "../../elements/loading";

class ProjectGoal extends Component {
	render (){
		const {project, goals, entities, municipalities, directories,resource_concepts, match} = this.props;
		return (
			project.registry.isFetching ? <Loading message="Cargando..."/> :
				<ProjectGoalEditForm
					fetching={project.registry.isFetching}
					modality={match.params.modality}
					state={match.params.state}
					municipality={match.params.municipality}
					registry={project.registry}
					goals={goals.list}
					proigualdadGoals={project.goals}
					entities={entities}
					municipalities={municipalities}
					directories={directories}
					resource_concepts={resource_concepts}
					permissions={project.permissions}
					match={this.props.match}
					change={this.props.change}
					fetchMunicipalities={this.props.fetchMunicipalities}
					add={this.props.add}
					remove={this.props.remove}
					projectProigualdadGoals={this.props.projectProigualdadGoals}
					history={this.props.history}
					setSystemNotification={this.props.setSystemNotification}
					saveRegistry={this.props.saveRegistry}
				/>
		);
	}

	componentWillMount() {
		let { modality, state, municipality } = this.props.match.params;
		this.props.fetchRegistry(modality, state, municipality);
	}

	componentWillReceiveProps(nextprops) {
		let { modality, state, municipality } = nextprops.match.params;
		if(nextprops.location.pathname !== this.props.location.pathname) {
			this.props.fetchRegistry(modality, state, municipality);
		}
	}
}

export default ProjectsLayout(ProjectGoal, {subnav: 3});



// WEBPACK FOOTER //
// ./src/layouts/project/registry.jsx